export default "__VITE_ASSET__BTSNBTYq__"